<template>
  <div>
    <v-row class="mt-5">
      <v-col cols="12">

        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <v-btn class="btn-invisible mr-5" @click.stop="showModal('empiecement-doudoune')">
                <v-icon class="mx-3" color="black darken-2" dark small>
                  mdi-image-multiple
                </v-icon>
              </v-btn>
              <p>
                La partie abîmée est recouverte de tissu.<br/>
                Cette réparation permet de recouvrir d’une matière la partie abimée en créant une forme d’empiècement en
                cohérence avec le design du produit.<br/>
                Les coutures de l’empiècement seront ré-étanchées.
              </p>
            </div>
            <p class="mt-5">
              <v-icon class="mx-3 mr-7" color="black darken-2" dark small>
                mdi-alert-circle-outline
              </v-icon>
              Nous ne sommes pas en capacité de refaire les membranes étanches si elles sont altérées / abimées
            </p>
          </v-col>
          <v-col v-for="(option, index) in options" :key="option.value" cols="12">
            <v-row>
              <v-col class="text-center" cols="7" offset-md="2">{{ option.label }}</v-col>
              <v-col class="text-center" cols="5" md="3">
                <plus-minus-field
                    :index="index"
                    :max="40"
                    :price="option.price"
                    :value="detailQte[index]"
                    @input="e => getInfos(e, option.bonus)"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <h6>EMPLACEMENT</h6>
            <v-textarea
                v-model="emplacement"
                name="input-7-4"
                outlined
                placeholder="Indiquez l'emplacement"
                counter="150"
                maxlength="150"
            />
            <image-preview
                :is-bonus-eligible="bonus > 0"
                :value="pictures"
                @change="v => pictures = v"
            />
          </v-col>
        </v-row>

      </v-col>
      <price :amount="price" :bonus="bonus" :display-bottom-line="price > 0"/>
    </v-row>
    <bonus-image-confirm
        v-if="bonus > 0 && pictures.length < 2"
        @skip-bonus="bonus = 0"
    />
    <confirm-flow
        v-else-if="price > 0"
        @finalize="noarticle"
        @new-repair="onSelectNewRepair"
        @new-article="noarticle(false)"
    />
  </div>
</template>
<script>
import {mapMutations, mapState} from 'vuex'
import prices from '../../assets/data/price/empiecement.json';
import Price from "@/components/shared/Price.vue";
import BonusImageConfirm from "@/components/shared/BonusImageConfirm.vue";
import ConfirmFlow from "@/components/shared/ConfirmFlow.vue";
import PlusMinusField from "@/components/interface/PlusMinusField.vue";
import ImagePreview from "@/components/interface/ImagePreview.vue";

let liste_reparations = []

export default {
  data() {
    return {
      options: [],

      quantity: 0,

      plumUpPrice: 5,
      pouchPrice: -3,
      callPrice: 5,
      pressingPrice: 35,

      price: 0,
      bonus: 0,
      detailQte: [],
      detailPrice: [],
      detailBonus: [],
      emplacement: null,
      reduction: 0,
      pictures: [],
      error: false,
      precision: false,
    }
  },
  computed: {
    ...mapState('cart-app', ['cards', 'products']),
    ...mapState('flux-app', ['flux']),
  },
  created() {
    this.options = prices[0][this.flux.level2].labels
  },
  methods: {
    ...mapMutations('flux-app', ['setConstat', 'setCptProduct', 'setcptReparation', 'setVerrou', 'setActiveTab', 'setLevel1', 'setLevel2', 'setLevel3', 'setComponentName']),
    ...mapMutations('cart-app', ['addProduct', 'getTotalCart']),
    getInfos(value, bonus) {
      this.quantity = 0
      this.$set(this.detailQte, value[0], value[1])
      this.$set(this.detailPrice, value[0], value[2])
      this.$set(this.detailBonus, value[0], (bonus ?? 0) * value[1])
      for (let i = 0; i < this.detailQte.length; i++) {
        this.quantity += this.detailQte[i] ?? 0
      }

      this.getPrice()
    },
    noarticle(showCart = true) {
      if (this.price <= 0) {
        return
      }

      this.storeProduct()
      this.setCptProduct(this.flux.cptProduct + 1)
      liste_reparations = []
      this.setcptReparation(0)


      this.$emit('evenement', 'scroll1')

      if (showCart) {
        this.setConstat('cart')
        this.$emit('showmodal', 'cart')
      }
    },
    onSelectNewRepair() {
      this.storeProduct()
      this.$emit('evenement', 'scroll3')
    },
    editProduct() {
      liste_reparations = this.products[this.flux.indexEditProduit].reparations
      //On check l'historique des réparations
      let index = liste_reparations.findIndex((obj => obj.id == (this.flux.indexEditReparation + 1)));
      if (index > -1) {
        let reparation = {
          id: liste_reparations[index].id,
          type: 'Empiècement',
          componentName: this.flux.level3,
          activeTab: 'empiecement-technique',
          emplacement: this.emplacement,
          precision: this.precision,
          qte: 1,
          price: this.price,
          bonus: this.pictures.length > 1 ? this.bonus : 0,
          pictures: this.pictures,
          details: [
            this.detailQte,
            this.detailPrice
          ],
          elements: [{labels: this.options.map(label => label.value)}]
        }

        this.products[this.flux.indexEditProduit].reparations.splice(index, 1, reparation)
        let data = {
          idLevel1: this.products[this.flux.indexEditProduit].idLevel1,
          level1: this.products[this.flux.indexEditProduit].level1,
          level2: this.products[this.flux.indexEditProduit].level2,
          level3: this.products[this.flux.indexEditProduit].level3,
          isDouble: this.products[this.flux.indexEditProduit].isDouble,
          id: this.products[this.flux.indexEditProduit].id,
          name: this.products[this.flux.indexEditProduit].name,
          famille: this.products[this.flux.indexEditProduit].famille,
          reparations: liste_reparations
        }

        this.addProduct(data)
        this.getTotalCart(this.products)
        this.$emit('evenement', 'scroll3')
      }
    },
    storeProduct() {
      if (this.price <= 0) {
        return
      }
      this.setcptReparation(this.flux.cptReparation + 1)

      if (this.flux.cptProduct < 1) {
        this.setCptProduct(this.flux.cptProduct + 1)
      }

      //On check l'historique des réparations
      liste_reparations = []
      let index = this.products.findIndex((obj => obj.id == this.flux.cptProduct));
      if (index > -1) {
        liste_reparations = this.products[index].reparations
      }

      liste_reparations.push({
        id: this.flux.cptReparation,
        type: 'Empiècement',
        componentName: this.flux.level3,
        activeTab: 'empiecement-technique',
        emplacement: this.emplacement,
        precision: this.precision,
        qte: 1,
        price: this.price,
        bonus: this.pictures.length > 1 ? this.bonus : 0,
        pictures: this.pictures,
        details: [
          this.detailQte,
          this.detailPrice
        ],
        elements: [{labels: this.options.map(label => label.value)}]
      })

      this.addProduct({
        idLevel1: this.flux.idLevel1,
        level1: this.flux.level1,
        level2: this.flux.level2,
        level3: this.flux.level3,
        isDouble: this.flux.isDouble,
        id: this.flux.cptProduct,
        name: this.flux.level2,
        famille: this.flux.level1,
        reparations: liste_reparations
      })
      this.setLevel3(null)
      this.setComponentName(null)
      this.getTotalCart(this.products)
    },
    showModal(constat) {
      this.setConstat(constat)
      this.$emit('showmodal')
    },
    getPrice() {
      this.price = 0
      this.bonus = 0
      for (let i = 0; i < this.detailPrice.length; i++) {
        this.price += (this.detailPrice[i] ?? 0)
        this.bonus += (this.detailBonus[i] ?? 0)
      }
    }
  },
  components: {
    ImagePreview,
    PlusMinusField,
    ConfirmFlow,
    BonusImageConfirm,
    Price
  }
}
</script>
